import React, { useState, useRef, useEffect } from 'react';

import moment from 'moment';

import SelectModal, { OptionsItem } from 'components/Selects/BookingSelectDate/components/Options';
import CustomSelect, { RenderProps as CustomSelectRenderProps } from 'components/Selects/CustomSelect';
import useStoreTranslation from 'hooks/useStoreTranslation';

interface Props {
  label?: string;
  initialValue?: string;
  handleChangeDate: (month: number) => void;
  className?: string;
  name?: string;
}

const MonthSelect = ({ label, initialValue, handleChangeDate, className, name }: Props) => {
  const { t } = useStoreTranslation();
  const periodRef = useRef(null);
  const [month, setMonth] = useState<string>();

  const months = moment.months().map((m, index) => ({ text: m, value: index + 1 } as OptionsItem));

  const handleChangePeriod = (value: string) => {
    setMonth(value);
    handleChangeDate(parseInt(value));
  };

  useEffect(() => {
    if (initialValue) setMonth(initialValue);
  }, [initialValue]);

  const makeValue = (month: string | undefined) => {
    if (month) {
      return months.find((m) => m.value === parseInt(month))?.text;
    }
    return '';
  };

  return (
    <div className={className} style={{ paddingTop: '4px' }}>
      <CustomSelect
        name={name}
        label={label ? label : t('guestForm.month.label')}
        onChange={handleChangePeriod}
        placeHolder={t('guestForm.month.placeholder')}
        selectRef={periodRef}
        value={makeValue(month)}
      >
        {({ ...selectProps }: CustomSelectRenderProps) => (
          <SelectModal {...selectProps} value={initialValue} selectRef={periodRef} items={months} />
        )}
      </CustomSelect>
    </div>
  );
};

export default MonthSelect;
